import script from "./LinkButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkButton.vue?vue&type=script&setup=true&lang=ts"

import "./LinkButton.vue?vue&type=style&index=0&id=d281a7dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d281a7dc"]])

export default __exports__